import { z } from "zod";

import { eventTypeAppCardZod } from "@calcom/app-store/eventTypeAppCardZod";

// Per-event-type activation, mirrors packages/app-store/gowa/zod.ts. `enabled` here is independent
// from the account/team-level Credential (apiToken/senderId, see lib/smsFactorCredentialKeysSchema.ts)
// — it only controls whether the manual reminder button is shown on this event-type's bookings, not
// whether SMSFactor itself is configured for the team/user. Kept even though SMSFactor's v1 scope
// (see specs/notif-sms-smsfactor/design.md) is limited to the existing SMS_ATTENDEE/SMS_NUMBER
// workflow actions rather than a new manual-reminder button — kept symmetrical with Gowa's zod.ts so
// both modules stay structurally interchangeable for IAbstractMessageService consumers.
export const appDataSchema = eventTypeAppCardZod.merge(z.object({}));
export const appKeysSchema = z.object({});
